import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
const EventOrder = new Enum(['SKIPPED', 'OCCURRED_AT_DESC']);
export const EventOption = ProtoBaseModel.extend({
  includeDisplayAttributes: attr(Boolean)
});
export const ListOption = ProtoBaseModel.extend({
  limit: attr(Number),
  order: attr(EventOrder),
  eventTypes: repeated(String),
  pagingKey: attr(String)
});